import { CommonData } from './common_schema'

export const criticalIssueData: CommonData[] = [
  {
    name: 'GC SafePoint should continue to move on',
    mean: '[manual]',
    std: '[manual]',
    location: '[manual] TiKV-Details -->TiKV Auto GC SafePoint'
  },
  {
    name: 'Check if exists big region',
    mean: 'TiKV_region_size:total.values.mean',
    std: 'TiKV_region_size:total.values.std',
    location: 'TiKV-Details -->Server --> approximate region size'
  },
  {
    name: 'Pseudo Estimation OPS(nodata+outdate)',
    mean: 'pseudo_estimation_total:total.values.mean',
    std: 'pseudo_estimation_total:total.values.std',
    location: 'TiDB-Details --> Statistics --> Pseudo Estimation OPS '
  },
  {
    name: 'CBO Stats Unhealthy Table Distribution (count the one !=100%)',
    mean: 'stats_unhealthy_pct:total.values.mean',
    std: 'stats_unhealthy_pct:total.values.std',
    location: 'TiDB-Details --> Statistics --> Stats Healthy Distribution'
  },
  {
    name: 'Check if Key Visualizer is evenly distributed',
    mean: '[manual]',
    std: '[manual]',
    location: '[manual] TiDB Dashboard --> Key Visualizer Page'
  }
]
